import PersonProfile from "@/components/PersonProfile";
import { PEOPLE, PERSON_LD } from "@/data/content";

const AngelaPuxi = () => (
  <PersonProfile
    person={PEOPLE.angela}
    testPrefix="angela"
    seoTitle="Angela Puxi – Freie Rednerin & Saxophonistin | Daviz & Puxi"
    seoDescription="Angela Puxi schreibt und spricht Reden für Willkommensfeiern, Trauungen und Jubiläen – und performt Ihr Lied live am Saxophon. Lernen Sie sie persönlich kennen."
    seoPath="/angela-puxi"
    seoLd={PERSON_LD(window.location.origin, {
      name: "Angela Puxi",
      jobTitle: "Freie Rednerin & Saxophonistin",
      image: PEOPLE.angela.image,
      path: "/angela-puxi",
    })}
  />
);

export default AngelaPuxi;
